export enum SiteTargetType {
    Employee = 1,
    Partner = 2
}